// extracted by mini-css-extract-plugin
export default {"wrap":"ea-z","heading":"fa-z","formError":"ga-z"};